<template>
  <div class="p-m-3 sp-page">
    <MockBanner />
    <div class="sp-row">
      <h2 style="margin: 0;">Projects</h2>
      <span class="sp-spacer"></span>
      <div class="p-d-flex p-ai-center" style="gap: 8px;">
        <InputSwitch id="spLiveOnly" v-model="liveOnly" />
        <label for="spLiveOnly" style="margin: 0;">Live only</label>
      </div>
      <span class="p-input-icon-left">
        <i class="pi pi-search" />
        <InputText v-model="search" placeholder="Search project, site, town, customer..." style="width: 20rem;" />
      </span>
      <Button label="New project" icon="pi pi-plus" class="p-button-success" @click="formVisible = true" />
    </div>
    <p class="sp-sub">One row per project. The status rolls up from its enquiries: Live while any enquiry is live, then Won if any was won, otherwise Closed.</p>

    <div class="p-card p-p-3">
      <DataTable
        :value="rows"
        :autoLayout="true"
        class="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        :rowHover="true"
        @row-click="e => open(e.data.id)"
      >
        <Column field="name" header="Project" :sortable="true">
          <template #body="s"><span class="sp-link">{{ s.data.name }}</span></template>
        </Column>
        <Column field="siteName" header="Site" :sortable="true" />
        <Column field="town" header="Town" :sortable="true" />
        <Column field="status" header="Status" :sortable="true">
          <template #body="s"><span :class="'sp-chip ' + s.data.status">{{ s.data.status }}</span></template>
        </Column>
        <Column field="productTypes" header="Product types" :sortable="true" />
        <Column field="nEnquiries" header="Enquiries" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="nCustomers" header="Customers" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="branches" header="Branches" :sortable="true" />
        <Column field="counted" header="Project-basis value £" :sortable="true">
          <template #body="s"><div class="sp-money">{{ money(s.data.counted) }}</div></template>
        </Column>
        <Column field="liveSum" header="Live quotes added up £" :sortable="true">
          <template #body="s"><div class="sp-money sp-muted">{{ money(s.data.liveSum) }}</div></template>
        </Column>
        <Column field="created" header="Created" :sortable="true" />
      </DataTable>
    </div>

    <ProjectForm v-if="formVisible" :visible="formVisible" @close="formVisible = false" @picked="onPicked" />
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import ProjectForm from './ProjectForm.vue'
import { projects, siteById, projectTotals, projectStatus, enquiriesOfProject, money } from './mockData'

export default {
  name: 'SpProjects',
  components: { MockBanner, ProjectForm },
  data() { return { search: '', liveOnly: false, formVisible: false, version: 0 } },
  computed: {
    rows() {
      this.version
      const q = this.search.toUpperCase()
      return projects
        .map(p => {
          const s = siteById(p.siteId)
          const t = projectTotals(p.id)
          const enq = enquiriesOfProject(p.id)
          return {
            ...p,
            siteName: s.name,
            town: s.town,
            status: projectStatus(p.id),
            productTypes: t.productTypes.join(', '),
            nEnquiries: t.nEnquiries,
            nCustomers: t.nCustomers,
            branches: [...new Set(enq.map(e => e.branch))].join(', '),
            counted: t.counted,
            liveSum: t.liveSum,
            customers: enq.map(e => e.customer).join(' ')
          }
        })
        .filter(r => !this.liveOnly || r.status === 'Live')
        .filter(r => !q || [r.name, r.siteName, r.town, r.customers].join(' ').toUpperCase().includes(q))
    }
  },
  methods: {
    money,
    open(id) { this.$router.push('/sitesProjects/projects/' + id) },
    onPicked(p) { this.formVisible = false; this.version++; this.open(p.id) }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
